import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRightIcon, BellIcon } from "@heroicons/react/24/solid";

import { useRecentMappingActivities } from "../api/getRecentMappingActivities";

import ProducerCodeNotificationTable from "./ProducerCodeNotificationTable";

const ProducerCodeNotifications = () => {
  const history = useHistory();
  const { data = [], isLoading, error } = useRecentMappingActivities(1000);

  return (
    <div className="px-8 py-4 space-y-6">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <BellIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
          <div className="flex flex-col leading-tight">
            <h3 className="text-xs font-medium text-gray-500">Producer Code</h3>
            <h1 className="font-bold text-primary text-md uppercase">
              NOTIFICATIONS
            </h1>
          </div>
        </div>

        <button
          type="button"
          onClick={() =>
            history.push("/carrieragreementmgmt/producercodeconfig")
          }
          className="inline-flex group hover:scale-90 transition duration-500 shadow-md px-3 py-1 h-7 text-xs font-semibold text-primary border hover:bg-primary hover:text-white border-primary rounded-md items-center"
        >
          <span>Back to Dashboard</span>
          <span className="ml-2 inline-flex items-center justify-center rounded-full h-4 w-4 bg-primary group-hover:bg-white transition">
            <ArrowRightIcon
              className="h-3 w-3 text-white group-hover:text-primary transform rotate-180"
              aria-hidden="true"
            />
          </span>
        </button>
      </div>

      <ProducerCodeNotificationTable data={data} isLoading={isLoading} />

      {error && (
        <div className="text-red-500 text-sm font-medium">
          Failed to load recent mapping activities.
        </div>
      )}
    </div>
  );
};

export default ProducerCodeNotifications;
